import { createClient } from '@lumi.new/sdk'

export const lumi = createClient({
  projectId: 'p441169817971544064',
  apiBaseUrl: 'https://api.lumi.new',
  authOrigin: 'https://auth.lumi.new',
})
